import { useSelector } from 'react-redux';
import { localeData } from '../core/bin/i18n.js'

export function ScaleText(path, _count, lineHeight) {
  let style = null
  const locale = useSelector(state => state.locale);
  const breakpoint = useSelector(state => state.breakpoint);

  const count = _count[breakpoint] || 0

  // homenav labels, scenav buttons
  if (Array.isArray(path)) {
    const text = path.map(p => p.split('.').reduce((o, i) => o[i], localeData[locale]))
    const words = text.map(txt => txt.split(' '))

    words.forEach(_words => {
      _words.forEach(word => {
        if (word.length > count) {
          const overCount = word.length - count
          const percentage = 100 - (overCount * 4) + '%'

          style = { fontSize: percentage, lineHeight: lineHeight }
        }
      })
    })
  }
  // infocard title
  else {
    const text = path.split('.').reduce((o, i) => o[i], localeData[locale])
    const words = text.split(' ')

    words.forEach(word => {
      if (word.length > count) {
        const overCount = word.length - count
        const percentage = 100 - (overCount * 6) + '%'

        style = { fontSize: percentage, lineHeight: lineHeight }
      }
    })
  }

  return style
}


// https://formatjs.io/docs/react-intl/upgrade-guide-2x/#flatten-messages-object
export function flattenMessages(nestedMessages, prefix = '') {
  return Object.keys(nestedMessages).reduce((messages, key) => {
    let value = nestedMessages[key];
    let prefixedKey = prefix ? `${prefix}.${key}` : key;
    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value, prefixedKey));
    }
    return messages;
  }, {});
}
